export default "__VITE_ASSET__BTH5o_Yc__"